import { gql } from "gql";

export const GET_CHILDREN = gql(/* GraphQL */ `
  query CompanyStructureSelectGetChildren(
    $types: [HierarchyElementType]
    $hierarchyType: HierarchyType!
  ) {
    getAllCompanyHierarchyElements(
      types: $types
      hierarchyType: $hierarchyType
    ) {
      ...CompanyStructureSelectOption
    }
  }
`);
